import { autoinject, bindable } from "aurelia-framework";
import { GridOptions } from "ag-grid";
import { I18N } from "aurelia-i18n";
import { Datasource, DatasourceFactory } from "../../services/datasource";
import { AuthService } from "../../services/auth/auth-service";
import { DialogFactory } from "../../services/dialog-factory";

@autoinject
export class GeometrieMatrix {
  @bindable() errorMessage?: string;

  gridOptions: GridOptions = {
    rowStyle: { textAlign: "center" },
    enableServerSideSorting: true,
    enableServerSideFilter: true,
    enableColResize: true,
    rowModelType: "infinite",
    paginationPageSize: 100,
    context: {
      // remember this view model, for later use in callbacks
      viewModel: this,
    },
  };

  private datasource: Datasource;

  constructor(
    datasourceFactory: DatasourceFactory,
    private dialogFactory: DialogFactory,
    private authService: AuthService,
    private i18n: I18N,
  ) {
    this.datasource = datasourceFactory.createDatasource(
      "admin/geometrie-matrix",
    );
    this.gridOptions.datasource =
      this.datasource.createGridDatasourceServerSideFiltering(undefined, []);
  }

  onGridSizeChanged() {
    this.gridOptions.api!.sizeColumnsToFit();
  }

  private reload() {
    this.gridOptions.api!.purgeInfiniteCache();
    this.errorMessage = undefined;
  }
}
